require('es6-shim');
import biLogger from '@wix/web-bi-logger';
import $ from 'jquery';
import { create as fedopsLoggerCreate } from '@wix/fedops-logger';
import fedopsJson from '../fedops.json';
import once from 'lodash/once';

const LIVE_SITE_OLO_SOCIAL_CLICK = 214;
const bi = biLogger.factory({endpoint: 'rest'}).updateDefaults({src: 61, evid: LIVE_SITE_OLO_SOCIAL_CLICK}).logger();
const fedopsLogger = fedopsLoggerCreate(fedopsJson['app_name']);

function getInstance() {
    try {
        const inst = location.search.match(/instance=([^&]+)/)[1];
        let instanceBase64 = inst.substr(inst.indexOf(".")+1);
        let instanceJson = atob(instanceBase64);
        return JSON.parse(instanceJson);
    } catch (e) {
        console.error('ERROR: no instance', e);
    }
}

function biEventDispatcher() {
    const params = getDefaultParams();

    return platform => {
        bi.log({
            ...params,
            platform,
        }).then(function() {
            // do something
        }).catch(function(err) {
            // do something
        });
    };
}

function getDefaultParams () {
    const instance = getInstance();

    return {
        visitorId: instance.uid || instance.aid,
        ownerId: instance.siteOwnerId,
        isMerchant: instance.uid === instance.siteOwnerId,
        msid: instance.metaSiteId,
        instance_id: instance.instanceId,
        bi_token: instance.biToken
    }
}

const reportFirstRender = once(() => {
    if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
        performance.mark('[perfer] app-loaded');
    }
});

$(document).ready(function () {
    $('.__preloader').remove();
    const sendBiEvent = biEventDispatcher();

    $('a').on('click', function () {
        const element = $(this);
        const platform = element.data('platform');
        const href = element.attr('href');

        if (href) {
            sendBiEvent(platform);
        }
    });
    fedopsLogger.appLoaded();
    reportFirstRender();
    if (typeof Wix !== 'undefined') {
        Wix.Performance.applicationLoaded();
    }

});



// WEBPACK FOOTER //
// ./viewer.js